"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EasypostConfigOutSerializer = void 0;
exports.EasypostConfigOutSerializer = {
    _fromJsonObject(object) {
        return {};
    },
    _toJsonObject(self) {
        return {};
    },
};
//# sourceMappingURL=easypostConfigOut.js.map